import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useNotification } from '../context/NotificationContext';
import { formatNumberPersian } from '../utils/mobileUtils';
import { formatPrice } from '../utils/priceUtils';
import { apiFetch } from '../utils/api';
import './Payment.css';

function Payment() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const { showNotification } = useNotification();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    fetchOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  const fetchOrder = async () => {
    try {
      const response = await apiFetch(`/api/orders/${orderId}`);
      if (response.ok) {
        const data = await response.json();
        setOrder(data);
      } else {
        showNotification('سفارش یافت نشد', 'error');
        navigate('/');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching order:', error);
      showNotification('خطا در دریافت اطلاعات سفارش', 'error');
      setLoading(false);
      navigate('/');
    }
  };

  const handleZibalPayment = async () => {
    setProcessing(true);
    try {
      const response = await apiFetch('/api/payments/zibal/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderId })
      });
      if (response.ok) {
        const data = await response.json();
        if (data.paymentUrl) {
          window.location.href = data.paymentUrl;
          return;
        }
      }
      showNotification('درگاه پرداخت در دسترس نیست. لطفاً بعداً دوباره تلاش کنید.', 'error');
      setProcessing(false);
    } catch (error) {
      console.error('Zibal request error:', error);
      showNotification('خطا در اتصال به درگاه پرداخت', 'error');
      setProcessing(false);
    }
  };

  if (loading) {
    return (
      <div className={`payment-container ${isDarkMode ? 'dark' : ''}`}>
        <div className="loading">در حال بارگذاری...</div>
      </div>
    );
  }

  if (!order) return null;

  return (
    <div className={`payment-container ${isDarkMode ? 'dark' : ''}`}>
      <div className="payment-content">
        <div className="payment-header">
          <h1>درگاه پرداخت</h1>
          <div className="payment-icon">💳</div>
        </div>
        <div className="payment-info">
          <div className="order-info-card">
            <h2>اطلاعات سفارش</h2>
            <div className="info-row">
              <span>شماره سفارش:</span>
              <strong>#{formatNumberPersian(order.id)}</strong>
            </div>
            <div className="info-row">
              <span>مبلغ قابل پرداخت:</span>
              <strong className="amount">{formatPrice(order.totalAmount)}</strong>
            </div>
            {order.discountAmount && order.discountAmount > 0 && (
              <div className="info-row discount">
                <span>تخفیف:</span>
                <span className="discount-amount">-{formatPrice(order.discountAmount)}</span>
              </div>
            )}
          </div>
          <div className="payment-methods">
            <h2>روش پرداخت</h2>
            <div className="payment-method-card selected">
              <div className="method-icon">💳</div>
              <div className="method-info">
                <h3>پرداخت آنلاین</h3>
                <p>پرداخت از طریق درگاه بانکی</p>
              </div>
              <div className="method-check">✓</div>
            </div>
          </div>
          <div className="payment-note">
            <p>پرداخت از طریق درگاه زیبال انجام می‌شود.</p>
          </div>
          <div className="payment-actions">
            <button className="btn-cancel" onClick={() => navigate('/')} disabled={processing}>انصراف</button>
            <button className="btn-pay" onClick={handleZibalPayment} disabled={processing}>
              {processing ? 'در حال انتقال...' : 'انتقال به درگاه پرداخت'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Payment;
